import * as actionTypes from "../actions/actionTypes";

const initialState = {
  hideHOF: false,
  hideDrivers: false,
  hideTeams: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.HIDE_BOTTOMNAV_HOF:
      console.log("Current state: ", state.hideHOF);
      console.log("Setting state");

      return {
        hideHOF: !state.hideHOF,
      };

    case actionTypes.HIDE_BOTTOMNAV_DRIVERS:
      return {
        hideDrivers: !state.hideDrivers,
      };

    case actionTypes.HIDE_BOTTOMNAV_TEAMS:
      return {
        hideDrivers: !state.hideTeams,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/hide.js